"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionItemHeading = exports.SPEC_ERROR = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var DisplayName_1 = __importDefault(require("../helpers/DisplayName"));
var uuid_1 = require("../helpers/uuid");
var ItemContext_1 = require("./ItemContext");
var defaultProps = {
    className: 'accordion__heading',
    'aria-level': 3,
};
exports.SPEC_ERROR = "AccordionItemButton may contain only one child element, which must be an instance of AccordionItemButton.\n\nFrom the WAI-ARIA spec (https://www.w3.org/TR/wai-aria-practices-1.1/#accordion):\n\n\u201CThe button element is the only element inside the heading element. That is, if there are other visually persistent elements, they are not included inside the heading element.\u201D\n\n";
var AccordionItemHeading = /** @class */ (function (_super) {
    __extends(AccordionItemHeading, _super);
    function AccordionItemHeading() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setRef = function (ref) {
            _this.ref = ref;
        };
        return _this;
    }
    AccordionItemHeading.VALIDATE = function (ref) {
        if (ref === undefined) {
            throw new Error('ref is undefined');
        }
        if (!(ref.childElementCount === 1 &&
            ref.firstElementChild &&
            ref.firstElementChild.getAttribute('data-accordion-component') === 'AccordionItemButton')) {
            throw new Error(exports.SPEC_ERROR);
        }
    };
    AccordionItemHeading.prototype.componentDidUpdate = function () {
        AccordionItemHeading.VALIDATE(this.ref);
    };
    AccordionItemHeading.prototype.componentDidMount = function () {
        AccordionItemHeading.VALIDATE(this.ref);
    };
    AccordionItemHeading.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-accordion-component": "AccordionItemHeading" }, this.props, { ref: this.setRef })));
    };
    AccordionItemHeading.defaultProps = defaultProps;
    return AccordionItemHeading;
}(React.PureComponent));
exports.AccordionItemHeading = AccordionItemHeading;
var AccordionItemHeadingWrapper = function (props) { return ((0, jsx_runtime_1.jsx)(ItemContext_1.Consumer, { children: function (itemContext) {
        var headingAttributes = itemContext.headingAttributes;
        if (props.id) {
            (0, uuid_1.assertValidHtmlId)(props.id);
        }
        return (0, jsx_runtime_1.jsx)(AccordionItemHeading, __assign({}, props, headingAttributes));
    } })); };
AccordionItemHeadingWrapper.displayName = DisplayName_1.default.AccordionItemHeading;
exports.default = AccordionItemHeadingWrapper;
//# sourceMappingURL=AccordionItemHeading.js.map